import {useCallback, useRef} from 'react'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {reportIssueFieldsUsage, type IssueFieldsUsageEvent} from './issue-fields-analytics'

export function useIssueFieldsAnalytics() {
  const enabled = isFeatureEnabled('issue_fields_report_usage')
  const interactionStart = useRef<number | null>(null)

  const markInteractionStart = useCallback(() => {
    interactionStart.current = Date.now()
  }, [])

  const reportUsage = useCallback(
    (event: Omit<IssueFieldsUsageEvent, 'interactionDuration'>) => {
      if (!enabled) return
      const interactionDuration = interactionStart.current ? Date.now() - interactionStart.current : undefined
      interactionStart.current = null
      reportIssueFieldsUsage({
        ...event,
        interactionDuration,
      })
    },
    [enabled],
  )

  return {markInteractionStart, reportUsage}
}
